// This file is kept for backward compatibility.
// All service implementations have been moved to ./services/ directory.
// Consumers importing from "@/lib/services" will resolve to this file.
// Re-export everything from the services directory barrel.
export * from "./services/index";
